import script from "./AppLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLoader.vue?vue&type=script&setup=true&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=c7a452d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a452d8"]])

export default __exports__